<template>
  <v-list
    subheader
    :disabled="disabled"
  >
    <v-list-item-group
      v-model="selectedDiscount"
      color="success"
    >
      <template v-for="d in discounts">
        <v-list-item :value="d.id">
          <v-list-item-title v-text="d.name" />
          <v-list-item-action-text v-if="!! d.isPercentage">
            {{ d.discount }}%
          </v-list-item-action-text>
          <v-list-item-action-text v-else>
            {{ d.discount | currency }}
          </v-list-item-action-text>
        </v-list-item>
        <v-divider />
      </template>
      <!--v-list-item
        @click=""
      >
        <v-list-item-title>{{ __('customDiscount') }}</v-list-item-title>
        <v-list-item-action>
          <v-icon v-text="icons.next" />
        </v-list-item-action>
      </v-list-item>
      <v-divider /-->
    </v-list-item-group>
    <template v-if="cancelable">
      <v-list-item @click="$emit('cancel')">
        <v-list-item-icon>
          <v-icon color="primary" v-text="icons.cancel" />
        </v-list-item-icon>
        <v-list-item-title>{{ __('cancelDiscount') }}</v-list-item-title>
      </v-list-item>
      <v-divider />
    </template>
  </v-list>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Currenciable,
      I18n,
      UsesIcons,
    ],

    props: {
      discounts: {
        required: true,
        type: Array,
      },
      selected: {
        required: true,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      cancelable () {
        return Boolean(this.selected?.id)
      },
      discount () {
        return this.discounts.find(o => o.id == this.selected?.id)
      },
      isSame () {
        return this.discount.discount == this.selected.discount
          && this.discount.isPercentage == this.selected.isPercentage
          && this.discount.withoutExtras == this.selected.withoutExtras
      },
      selectedDiscount: {
        get () {
          return this.discount && this.isSame ? this.discount.id : null
        },
        set (id) {
          id !== undefined
            ? this.$emit('apply', this.discounts.find(o => o.id == id))
            : this.$emit('cancel')
        },
      },
    },
  }
</script>
